import { DropdownWithSearch } from "InnoUI/innoinput";
import { sendTypeOption } from "utils/optionData/utils";

const SendTypeDropdown = ({
  onChange = () => {},
  defaultValue,
  disabled = true,
  name,
  disabledDropdown,
  active,
}) => {
  const Options = sendTypeOption.map((data) => ({
    id: data.id,
    label: data.label,
  }));

  const handleDropdownChange = (value) => {
    const selectedOption = Options.find((option) => option.id === value);
    const selectedLabel = selectedOption ? selectedOption.id : "";
    onChange(name, selectedLabel, active);
  };

  return (
    <DropdownWithSearch
      defaultValue={defaultValue}
      options={Options}
      onChange={handleDropdownChange}
      borderColor="#E36E00"
      disabled={disabled}
      width="313px"
      dropdowType={name}
      placeholder="Select send type"
              height="40px"
      disabledDropdown={disabledDropdown}
    />
  );
};

export default SendTypeDropdown;
